import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function IPerfExample() {
    return (
        <React.Fragment>
            <h3>100% Packet Loss</h3>
            <p>
                Transfers with 100% packet loss typically indicates that the source or destination firewall is not
                configured correctly, or the servers are not able to connect to each other via the network. Ensure that
                your firewall is configured correctly and that both machines are connected to the network.
            </p>
            <h3>Partial Packet Loss</h3>
            <p>
                Transfers that fail to transfer a small percentage of packets can indicate that the bandwidth allocated
                exceeds network capacity. Lowering the bandwidth typically reduces the number of lost packets, helping
                to determine your optimal transfer speed.
            </p>
            <p>
                <strong>Note</strong>: Signiant transfers account for partial packet loss and, within the 1-3% range,
                throttle the transfer speed to ensure transfer success.
            </p>
        </React.Fragment>
    );
}

IPerfExample.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(IPerfExample);
